const postWebViewMessage = (type, data = {}) => {
  window.ReactNativeWebView?.postMessage(JSON.stringify({
    type,
    ...data
  }));
};

const appNavigate = (tab, params = {}) => {
  postWebViewMessage('navigate', { tab, params });
};

const postLoginStatus = ({ isLoggedIn, username }) => {
  postWebViewMessage('loggedIn', { isLoggedIn, username });
};

export { appNavigate, postWebViewMessage, postLoginStatus };